angular.module('unergie.main')
.factory('RouterService', ($rootScope, $window, DataAccess) =>
    ({
        openContract(idContract) {
            return DataAccess.accountForContract({ id_contract: idContract }).$promise
            .then((result) => {
                if (result && result.customer_id) {
                    const url = `/info/${result.customer_id}/${idContract}`
                    return $window.open(url, '_blank')
                }
            })
        },
    }),
)
